import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { State } from '@progress/kendo-data-query';
@Injectable({
    providedIn: 'root',
})
export class SiteSearchService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5'; // TODO Get version dynamically
    private _url = (this.serverUrl + '/api/v{version}/sitesearch').replace(
        '{version}',
        this.version
    );
    constructor(private http: HttpClient) {}

    public state: State = {
        skip: 0,
        take: 5,
        filter: { filters: [], logic: 'or' },
        group: [],
        sort: [],
    };

    getSiteSearchResults(
        search: string,
        searchType: string,
        offset: number,
        fetch: number,
        sort: string,
        allResults: boolean
    ): Observable<any> {
        if (!search.trim()) {
            return of([]);
        }
        return this.http
            .post<SiteSearchDataModel[]>(this._url + '/GetSiteSearchData', {
                Search: search,
                SearchType: searchType,
                Offset: offset,
                Fetch: fetch,
                Sort: sort,
                AllResults: allResults,
            })
            .pipe(timeout(6500));
    }
}

export interface SiteSearchDataModel {
    identifier: string;
    name: string;
    description: string;
    rowType: string;
    totalRows: number;
    requestByEmail: string;
    pendingDelete: boolean;
    loanNumber: string;
    requestedDate: Date;
    processedDate?: Date;
    requestedByEmail?: string;
}
